import { Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import ProjectForm from '../ProjectForm'
import React, { useEffect, useState } from 'react'

import { Form } from 'antd'
import { SpinWrapper } from '../../../../../../OnBoarding/Register/Education/style'
import { searchAPI, setResumeData } from '../../../../../../OnBoarding/actions'
import {
  AdjustIcon,
  FooterFlex,
  StyledDrawer,
} from '../../DrawerStyle'
import { SubHeading1 } from '../../EducationDetailStyle'
import {
  ButtonLocal,
  Text,
} from '../style'
import { useDispatch } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { searchConfig } from 'utils/config'
import { getStudentDataById } from '../../../../../actions'
import instRequest from '../../../../../../../utils/instRequest'
import UpdatePopup  from '../../../UpdatePopup'
import SuccessPopupModal from '../../../SuccessPopup'

const InternshipDrawer = ({
  drawerStatus,
  setdrawerStatus,
  updateStudentData,
  studentFormData,
  pendingData,
  getPendingData,
  listOfStudentSkills,
  getListOfSkills,
  studentId,
}) => {
  const [form] = Form.useForm()
  const dispatch = new useDispatch()
  const [internship, setInternship] = useState([])
  const [corporateName, setCorporateName] = useState([])
  const [corporateId, setCorporateId] = useState('')
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)
  const [skillLoading, setSkillLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [listOfSkills, setListOfSkills] = useState([])
  const [updated, setUpdated] = useState(false)
  const [shown, setShown] = useState([])
  const [listOfAddedSkills, setListOfAddedSkills] = useState([])
  const [tpoConfig, setTpoConfig] = useState(null)
  const [frozenFieldsMap, setFrozenFieldsMap] = useState({})
  const [isAddNewFrozen, setIsAddNewFrozen] = useState(false)
  const [showUpdatePopup, setShowUpdatePopup] = useState(false)
  const [succesPopup, setSuccessPopup] = useState(false)
  const SkillsAPI = async (page, search) => {
    try {
      const results = await dispatch(
        searchAPI(searchConfig?.skills?.name, search, searchConfig?.skills)
      )
      let v = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      }

      let updatedSkills = results || []
      if (updatedSkills?.length === 0 && search) {
        setListOfAddedSkills([...listOfAddedSkills, v])
        setListOfSkills([...updatedSkills, v])
      }
      const isExactMatch = updatedSkills?.some(
        skill => skill?.name.toLowerCase() === search?.toLowerCase()
      )
      if (updatedSkills?.length > 0) {
        if (!isExactMatch && search?.length > 3) {
          setListOfAddedSkills([...listOfAddedSkills, v])
          setListOfSkills([...updatedSkills, v])
        } else {
          setListOfSkills(updatedSkills)
        }
      }
    } catch (error) {
      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }
  const pendingInternship = pendingData?.resume?.internships?.length > 0

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSkillLoading(true)
        await SkillsAPI(0)
      } finally {
        setSkillLoading(false)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    const fetchTpoConfig = async () => {
      try {
        const instituteCampusId = studentFormData?.student?.instituteCampusId
        if (instituteCampusId) {
          const response = await instituteRequest.get(
            `/institutes/${instituteCampusId}/tpo-approval-config`
          )
          if (response?.data?.data) {
            setTpoConfig(response.data.data)
          }
        }
      } catch (error) {
        console.error('Error fetching TPO config:', error)
      }
    }
    fetchTpoConfig()
  }, [studentFormData?.student?.instituteCampusId])

  useEffect(() => {
    if (!tpoConfig || !tpoConfig.tpoApprovalConfig || !tpoConfig.tpoApprovalConfig.fields) {
      setFrozenFieldsMap({})
      setIsAddNewFrozen(false)
      return
    }

    const approvedInternships = studentFormData?.resume?.internships || []
    const frozen = {}
    const fields = tpoConfig.tpoApprovalConfig.fields
    
    const addNewConfig = fields['internships.addNew']
    const hasApprovedInternships = approvedInternships.length > 0
    setIsAddNewFrozen(addNewConfig?.freezeAfterVerification && hasApprovedInternships)

    approvedInternships.forEach((internship) => {
      if (!internship.id) return
      const internshipId = internship.id
      frozen[internshipId] = {}

      const fieldMappings = {
        'title': 'title',
        'organization': 'organization',
        'started_in': ['startMonth', 'startYear'],
        'ended_in': ['endMonth', 'endYear'],
        'description': 'description',
        'skill_set': 'skill_set',
        'certifications': 'certifications',
        'function': 'function',
        'role': 'role',
        'industry': 'industry',
        'awards': 'awards'
      }

      Object.entries(fieldMappings).forEach(([uiField, configFields]) => {
        const configFieldArray = Array.isArray(configFields) ? configFields : [configFields]
        
        const shouldFreeze = configFieldArray.some(configField => {
          const fullFieldName = `internships.${configField}`
          const fieldConfig = fields[fullFieldName]
          return fieldConfig && fieldConfig.freezeAfterVerification
        })

        if (shouldFreeze) {
          const fieldValue = internship[uiField]
          const hasValue = fieldValue !== null && fieldValue !== undefined && fieldValue !== '' && 
                           (!Array.isArray(fieldValue) || fieldValue.length > 0)
          if (hasValue) {
            frozen[internshipId][uiField] = true
          }
        }
      })
    })

    setFrozenFieldsMap(frozen)
  }, [tpoConfig, studentFormData?.resume?.internships])

  useEffect(() => {
    try {
      let internshipList = []
      
      const approvedInternships = studentFormData?.resume?.internships || []
      const pendingRequests = pendingData?.requests || []
      
      // Transform API pending data structure
      const internshipPendingMap = new Map()
      pendingRequests.forEach(request => {
        if (request.fieldName?.startsWith('internships.') && request.itemId) {
          if (!internshipPendingMap.has(request.itemId)) {
            internshipPendingMap.set(request.itemId, {})
          }
          const fieldName = request.fieldName.replace('internships.', '')
          //internshipPendingMap.get(request.itemId)[fieldName] = {
          // Map 'certifications' to 'certificate' for consistency with form field name
          const mappedFieldName = fieldName === 'certifications' ? 'certificate' : fieldName    //new
          internshipPendingMap.get(request.itemId)[mappedFieldName] = {            //new
            value: request.requestedData,
            originalValue: request.originalData,
            status: request.status,
            _requestId: request.id
          }
        }
      })
      
      // Check for new internship items
      const newInternshipRequests = pendingRequests.filter(request => 
  request.fieldName === 'internships' &&
  request.isNewItem === true &&
  request.status === 'PENDING'
)
      
      const mergedInternships = approvedInternships.map(approvedIntern => {
        const pendingFields = internshipPendingMap.get(approvedIntern.id)
        
        if (pendingFields && Object.keys(pendingFields).length > 0) {
          const merged = { ...approvedIntern }
          
          Object.keys(pendingFields).forEach(fieldName => {
            merged[fieldName] = pendingFields[fieldName].value
          })
          
          merged._hasPendingChanges = true
          merged._pendingFields = pendingFields
          
          return merged
        }
        
        return approvedIntern
      })
      
      // Handle new pending internships
      const newPendingInternships = []

newInternshipRequests.forEach(request => {

  const newInternship = {
    ...request.requestedData,
    id: request.itemId,
    _isNew: true,
    _hasPendingChanges: true,
    _pendingFields: {}
  }

  Object.keys(request.requestedData || {}).forEach(fieldName => {

    newInternship._pendingFields[fieldName] = {
      value: request.requestedData[fieldName],
      originalValue: null,
      status: request.status,
      _requestId: request.id
    }

  })

  newPendingInternships.push(newInternship)

})

      
      const allInternships = [...mergedInternships, ...newPendingInternships]
      
      allInternships.map((data, index) => {
      let formName = 'internship_' + index
      const formattedDescription = Array.isArray(data?.description)
        ? data.description.map(item => `${item}`).join('\n')
        : data?.description
      form.setFieldsValue({
        [formName]: {
          id: data?.id,
          temp_id: data?.temp_id,
          title: data?.title,
          corporateId: data?.corporateId,
          organization: data?.organization,
          started_in: data?.started_in,
          ended_in: data?.ended_in,
          industry: data?.industry,
          function: data?.function,
          role: data?.role,
          description: formattedDescription,
          skill_set: data?.skill_set,
          certificate: data?.certificate,
          awards: data?.awards,
          isDelete: false,
          shown: true,
        },
      })
      return internshipList.push({
        component: ProjectForm,
        formName: formName,
      })
    })
      setInternship(internshipList)
    } catch (error) {
      console.error('Error in InternshipDrawer useEffect:', error)
      setInternship([])
    }
  }, [studentFormData, pendingData])
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  const internshipHandler = (isAdd, isDelete, deleteForm) => {
    const experienceKeys = Object.keys(form.getFieldValue())

    let lastValue = 0
    for (let i = experienceKeys.length - 1; i >= 0; i--) {
      const key = experienceKeys[i]
      const intValue = parseInt(key.split('_')[1])
      if (!isNaN(intValue)) {
        lastValue = intValue
        break
      }
    }
    let arr = []
    let formName = 'internship_' + `${lastValue + 1}`

    arr.push({ component: ProjectForm, formName: formName })
    if (isAdd) {
      setIsUpdateButtonEnabled(false)
      return setInternship([...internship, ...arr])
    }
    if (isDelete) {
      form.setFieldValue([[deleteForm], 'isDelete'], true)
      setIsUpdateButtonEnabled(false)
      let updatedList = internship?.filter(
        data => data?.formName !== deleteForm
      )
      return setInternship(updatedList)
    }
  }
  const submitHandler = async () => {
    if (submitLoading) {
      return
    }
    
    setSubmitLoading(true)
    
    try {
      let internship = []
      const values = await form.getFieldValue()

      const errorList = []
      await form
        .validateFields()
        .then()
        .catch(err => {
          errorList.push(err?.errorFields)
        })
      if (!errorList?.length) {
      Object.entries(values).forEach(([name, obj]) => {
        if (
          name.includes('internship') &&
          !name.includes('award') &&
          !obj?.isDelete
        ) {
          internship.push({
            ...obj,
            awards: [],
          })
        }
      })

      let awardInternData = []
      Object.entries(internship).forEach((data, index) => {
        Object.entries(values).forEach(([name, obj]) => {
          if (name.includes('internship_' + index + 'award')) {
            let load = {
              [index]: obj,
            }
            awardInternData.push(load)
          }
        })
      })

      for (let i = 0; i < internship.length; i++) {
        for (const [key, value] of Object.entries(awardInternData)) {
          for (const [key1, value1] of Object.entries(value)) {
            if (key1 == i) {
              internship[i].awards.push(value1)
            }
          }
        }
      }

      internship = internship.map(proj => ({
        ...proj,
        skill_set: proj.skill_set
          ? proj.skill_set.map(skill => ({
              id: uuidRegex.test(skill.id) ? skill.id : '',
              name: skill.name,
            }))
          : [],
      }))

      // Track new internships for frontend pending state
      const existingInternshipIds = new Set((studentFormData?.resume?.internships || []).map(intern => intern.id))
      
      internship.forEach((intern, index) => {
        // If this is a new item (no ID or not in existing items), mark as new without temp ID
        if (!intern.id || !existingInternshipIds.has(intern.id)) {
          intern._isNew = true
        }
      })

      let payload = {
        refreshRanking: true,
        isDirectTPOUpdate: true,
        checkDeleteSection: ['internships'],
        admin: {
          ...studentFormData?.admin,
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: studentFormData?.student ? {
          ...studentFormData?.student,
          id: studentId,
          instituteCampusId: studentFormData?.student?.instituteCampusId || studentFormData?.admin?.institute_campus_id,
        } : { 
          id: studentId,
          instituteCampusId: studentFormData?.admin?.institute_campus_id,
        },
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? {
              ...studentFormData?.currentCourse,
              marks: studentFormData?.currentCourse?.marks ?? 0,
            }
          : {},
        education: studentFormData?.education,
        resume: {
          ...studentFormData?.resume,
          internships: internship,
        },
      }

      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === '') {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.registraionNo) {
        delete payload?.studentPersonalProfile?.registraionNo
      }
      studentFormData?.education?.map((item, index) => {
        if (item?.skills === null) delete payload?.education?.[index]?.skills
        if (item?.degreeStreamMapId === null)
          delete payload?.education?.[index]?.degreeStreamMapId
      })
      payload?.resume?.internships.map((item, index) => {
        if (
          item?.certificate == null ||
          Object.keys(item?.certificate)?.length === 0
        ) {
          delete payload?.resume?.internships[index]?.certificate
        }
        delete payload?.resume?.internships[index]?.startMonth
        delete payload?.resume?.internships[index]?.startYear
        delete payload?.resume?.internships[index]?.endMonth
        delete payload?.resume?.internships[index]?.endYear
      })
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      const response = await updateStudentData(payload)
      await dispatch(setResumeData(payload))
      
      dispatch(getStudentDataById(studentId)).catch(err => console.error('getStudentData error:', err))
      getPendingData().catch(err => console.error('getPendingData error:', err))
      
      setSubmitLoading(false)
      
      if (response?.success === true) {
        SuccessMessage('Internship saved successfully!')
        setdrawerStatus(false)
        setUpdated(true)
      } else {
        ErrorMessage(response?.response?.data?.message)
      }
    } else {
      const errorForms = []

      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })

      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
    } catch (error) {
      console.error('Error in submitHandler:', error)
      ErrorMessage('An error occurred while submitting. Please try again.')
      setSubmitLoading(false)
    }
  }

  const content = () => {
    return (
      <>
        <Form
          scrollToFirstError
          onFinish={submitHandler}
          id={'internForm'}
          form={form}
          layout="vertical"
        >
          {!!internship?.length &&
            internship?.map((obj, index) => {
              const approvedInternships = studentFormData?.resume?.internships || []
              const pendingRequests = pendingData?.requests || []
              
              // Transform API pending data structure
              const internshipPendingMap = new Map()
              pendingRequests.forEach(request => {
                if (request.fieldName?.startsWith('internships.') && request.itemId) {
                  if (!internshipPendingMap.has(request.itemId)) {
                    internshipPendingMap.set(request.itemId, {})
                  }
                  const fieldName = request.fieldName.replace('internships.', '')
                  //internshipPendingMap.get(request.itemId)[fieldName] = {
                  // Map 'certifications' to 'certificate' for consistency with form field name
                  const mappedFieldName = fieldName === 'certifications' ? 'certificate' : fieldName    //new
                  internshipPendingMap.get(request.itemId)[mappedFieldName] = {            //new
                    value: request.requestedData,
                    originalValue: request.originalData,
                    status: request.status,
                    _requestId: request.id
                  }
                }
              })
              
              // Check for new internship items
              const newInternshipRequests = pendingRequests.filter(request => 
                request.fieldName === 'internships' &&
                request.isNewItem === true &&
                request.status === 'PENDING'
              )
              
              const mergedInternships = approvedInternships.map(approvedIntern => {
                const pendingFields = internshipPendingMap.get(approvedIntern.id)
                
                if (pendingFields && Object.keys(pendingFields).length > 0) {
                  const merged = { ...approvedIntern }
                  Object.keys(pendingFields).forEach(fieldName => {
                    merged[fieldName] = pendingFields[fieldName].value
                  })
                  merged._hasPendingChanges = true
                  merged._pendingFields = pendingFields
                  return merged
                }
                return approvedIntern
              })
              
              const newPendingInternships = []
              newInternshipRequests.forEach(request => {
                const newInternship = {
                  ...request.requestedData,
                  id: request.itemId,
                  _isNew: true,
                  _hasPendingChanges: true,
                  _pendingFields: {}
                }
                Object.keys(request.requestedData || {}).forEach(fieldName => {
                  newInternship._pendingFields[fieldName] = {
                    value: request.requestedData[fieldName],
                    originalValue: null,
                    status: request.status,
                    _requestId: request.id
                  }
                })
                newPendingInternships.push(newInternship)
              })
              
              const allInternships = [...mergedInternships, ...newPendingInternships]
              const currentInternship = allInternships[index]
              const internshipId = currentInternship?.id
              const frozenFields = internshipId ? frozenFieldsMap[internshipId] || {} : {}
              
              return (
                <obj.component
                  key={index + 'internship'}
                  form={form}
                  onRemove={internshipHandler}
                  formName={obj?.formName}
                  studentFormData={studentFormData}
                  listOfStudentSkills={listOfStudentSkills}
                  getListOfSkills={getListOfSkills}
                  setCorporateName={setCorporateName}
                  corporateName={corporateName}
                  setCorporateId={setCorporateId}
                  corporateId={corporateId}
                  setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                  skillLoading={skillLoading}
                  setSkillLoading={setSkillLoading}
                  listOfSkills={listOfSkills}
                  SkillsAPI={SkillsAPI}
                  shown={shown}
                  frozenFields={frozenFields}
                  pendingFields={currentInternship?._pendingFields || {}}
                  isNew={currentInternship?._isNew || false}
                />
              )
            })}
        </Form>
        <SubHeading1>Note:</SubHeading1>
        <SubHeading1>
          Please fill in all details in the section below to ensure exposure to
          maximum number of corporates
        </SubHeading1>
        <ButtonLocal 
          onClick={() => !isAddNewFrozen && internshipHandler(true, false)}
          disabled={isAddNewFrozen}
          style={{ 
            opacity: isAddNewFrozen ? 0.5 : 1, 
            cursor: isAddNewFrozen ? 'not-allowed' : 'pointer' 
          }}
        >
          <Control alignCenter gap="10px">
            <AdjustIcon>
              <AddIcon />
            </AdjustIcon>
            <Text>Add internship</Text>
          </Control>
        </ButtonLocal>
        {studentFormData?.resume?.internships?.length > 0 && skillLoading && (
          <SpinWrapper center>
            <Spin />
          </SpinWrapper>
        )}
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary
          onClick={async () => {
            try {
              await form.validateFields()
              if(!pendingInternship) {                
                form.submit()
              }
              else {
                setShowUpdatePopup(true)
              }
            } catch (err) {
            }
          }}
          text={'Update'}
          disabled={isUpdateButtonEnabled || submitLoading}
          loading={submitLoading}
        />
      </FooterFlex>
    )
  }
  return (
    <>
              <UpdatePopup
            form={'internForm'}
            htmlType="submit"
            open={showUpdatePopup}
            loading={submitLoading}
            onCancel={() => setShowUpdatePopup(false)}
            onConfirm={() => {
              setShowUpdatePopup(false)
              setSuccessPopup(true)
              form.submit()  
            }}
          />
          <SuccessPopupModal
            open={succesPopup}
            onClose={() => setSuccessPopup(false)}
          />
    <StyledDrawer
      width="675px"
      title={'Internship Details'}
      placement="right"
      closable={true}
      onClose={() => setdrawerStatus(false)}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
    </>
  )
}

export default InternshipDrawer
